import { useEffect, useRef } from "react";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";

const FloatingCircles = () => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll();
  
  // Smooth spring animation
  const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 50,
    damping: 20
  });

  // Create multiple circle configurations
  const circles = [
    { size: 400, left: -100, top: 200, speed: 0.3, opacity: 0.08 },
    { size: 300, right: -80, top: 600, speed: -0.2, opacity: 0.06 },
    { size: 500, left: "20%", top: 1200, speed: 0.4, opacity: 0.05 },
    { size: 250, right: "10%", top: 1800, speed: -0.35, opacity: 0.07 },
    { size: 350, left: "5%", top: 2400, speed: 0.25, opacity: 0.06 },
    { size: 450, right: -150, top: 3000, speed: -0.15, opacity: 0.08 },
    { size: 280, left: "30%", top: 3600, speed: 0.3, opacity: 0.05 },
    { size: 380, right: "25%", top: 4200, speed: -0.25, opacity: 0.07 },
    { size: 320, left: -80, top: 4800, speed: 0.35, opacity: 0.06 },
    { size: 420, right: "5%", top: 5400, speed: -0.2, opacity: 0.08 },
  ];

  return (
    <div 
      ref={containerRef}
      className="fixed inset-0 pointer-events-none overflow-hidden z-0"
      aria-hidden="true"
    >
      {circles.map((circle, index) => (
        <CircleElement 
          key={index}
          circle={circle}
          scrollProgress={smoothProgress}
        />
      ))}
    </div>
  );
};

const CircleElement = ({ circle, scrollProgress }) => {
  const y = useTransform(
    scrollProgress,
    [0, 1],
    [0, circle.speed * 1000]
  );

  const rotate = useTransform(
    scrollProgress,
    [0, 1],
    [0, circle.speed > 0 ? 180 : -180]
  );

  const scale = useTransform(
    scrollProgress,
    [0, 0.5, 1],
    [1, 1.1, 1]
  );

  return (
    <motion.div
      className="absolute rounded-full"
      style={{
        width: circle.size,
        height: circle.size,
        left: circle.left,
        right: circle.right,
        top: circle.top,
        y,
        rotate,
        scale,
        background: `radial-gradient(circle at 30% 30%, rgba(240, 90, 40, ${circle.opacity + 0.02}), rgba(240, 90, 40, ${circle.opacity}))`,
        boxShadow: `0 0 ${circle.size / 4}px rgba(240, 90, 40, ${circle.opacity / 2})`,
      }}
    />
  );
};

export default FloatingCircles;
